import React, {FC} from "react";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useSignIn} from "../../hooks/useSignIn";
import {Menu, MenuItem, TextField, Typography} from "@mui/material";
import {LABEL, SUPPORTED_LANGUAGES} from "../../../../../newShared/constants";
import {useThreeDotsMenu} from "../../../../../newShared/hooks/useThreeDotsMenu";
import {DropdownButton, LoadingButton} from "../../../../../newShared/components/Basic/CommonButtons";
import {Language} from "@mui/icons-material";
import {useForm} from "../../../../../newShared/hooks/useForm";
import {useRoutes} from "../../hooks/useRoutes";
import colors from "../../../../../newShared/theme/colors";
import {useDispatch} from "react-redux";
import {SendEmailSupportAction} from "../../store/actions";
import {useMessageDialog} from "../../../../barsEnvironment/MessageDialog/hooks/useMessageDialog";

export const BlockContactUs: FC = () => {
    const {setMessage} = useMessageDialog();
    const {t, currentLanguage: {name, code}, handleChooseLanguage} = useMainTranslation('', {keyPrefix: 'pathLogin.loginPageSupportDialog'});

    const dispatch = useDispatch();
    const sendEmail = () => {
        dispatch(SendEmailSupportAction({data: form, onSuccess}));
    }

    const onSuccess = () => {
        goToLogin();
        setMessage({
            title: t('Completed successfully!'),
            message: t('{{companyName}} team will contact you soon!', {companyName: LABEL})
        })
    }

    const {
        isLoading: {isSendingEmail}
    } = useSignIn();
    const {goToLogin} = useRoutes();

    const {form, handleChange} = useForm<{email: string, name: string, message: string}>({email: '', name: '', message: ''});

    const {anchorThreeDotsEl, handleThreeDotsOpen, handleThreeDotsClose} = useThreeDotsMenu();

    const disabled = form.email.trim() === '' || form.name.trim() === '' || form.message.trim() === '';
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (!disabled && e.key === 'Enter') {
            sendEmail();
        }
    };

    return (
        <>
            <Typography variant={"h1"} textAlign={"center"}>{t('Contact us')}</Typography>

            <DropdownButton value={code} sx={{m: '32px auto 0', alignSelf: 'center'}} variant={"text"}
                            icon={<Language/>} open={!!anchorThreeDotsEl} onClick={handleThreeDotsOpen}>
                <Typography variant={"body1"}>{name}</Typography>
            </DropdownButton>
            <Menu open={!!anchorThreeDotsEl} anchorEl={anchorThreeDotsEl} onClose={handleThreeDotsClose}>
                {SUPPORTED_LANGUAGES.map((e) => (
                    <MenuItem value={e.code} key={e.code}
                              sx={{width: anchorThreeDotsEl?.offsetWidth}}
                              onClick={() => {
                                  handleChooseLanguage(e.code);
                                  handleThreeDotsClose();
                              }}>
                        {e.name}
                    </MenuItem>
                ))}
            </Menu>

            <TextField name={'email'} required label={t('Email')} value={form.email} onChange={handleChange} onKeyDown={handleKeyDown}
                       sx={{mt: '16px'}} type={"email"}/>

            <TextField name={'name'} required label={t('Full Name')} value={form.name} onChange={handleChange} onKeyDown={handleKeyDown}
                       sx={{mt: '16px'}}/>

            <TextField name={'message'} required label={t('Describe your message')} value={form.message} onChange={handleChange} onKeyDown={handleKeyDown}
                       sx={{mt: '16px'}} multiline minRows={3} maxRows={3}/>

            <LoadingButton loading={isSendingEmail} onClick={sendEmail}
                           disabled={disabled}
                           sx={{mt: '16px', alignSelf: 'flex-start'}}>
                {t('Send')}
            </LoadingButton>

            <Typography sx={{mt: '16px', fontWeight: 500, fontSize: '18px', lineHeight: '24px'}}>
                {`${t('Return to')} `}<span onClick={goToLogin} style={{color: colors.primary.blue, cursor: 'pointer', fontWeight: 600}}>{t('Log In')}</span>
            </Typography>
        </>
    )
}
